import { render, staticRenderFns } from "./RiskAssessment.vue?vue&type=template&id=52fa7547"
import script from "./RiskAssessment.vue?vue&type=script&lang=ts"
export * from "./RiskAssessment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports